<template>
  <div class="fullBox">
    <div class="add_item" @click="add">
      <i class="el-icon-plus"></i>
      新增地点
    </div>
    <div class="item" v-for="(i, index) in list" :key="index">
      <div class="top">
        <div class="left">
          <!-- <img v-if="i.image" :src="imgUrl + i?.image" alt="" /> -->
          <img src="@/assets/logistics/location/umbrella.png" alt="" />
        </div>
        <div class="right">
          <div class="title">{{ i.place }}</div>
          <div class="address">地&emsp;址：{{ i.address }}</div>
          <div class="name">管理员：{{ i.adminName }}</div>
          <div class="state">
            启&emsp;用：<el-switch
              style="display: block"
              v-model="i.state"
              active-color="#4FA27D"
              disabled
            >
            </el-switch>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="bot">
        <div class="left" @click="getCode(i)">
          <img src="@/assets/logistics/location/qrcode.png" alt="" />
          <span>生成二维码</span>
        </div>
        <div class="right" @click="edit(i)">
          <img src="@/assets/logistics/location/edit.png" alt="" />
          <span>编辑</span>
        </div>
      </div>
    </div>
    <MyDialog
      :visible.sync="uploadDialog"
      :itemList="itemList"
      @changeSubmit="changeSubmit"
    />
    <MyQrCodeDialog :visible.sync="uploadQrcodeDialog" :itemList="itemList" />
  </div>
</template>

<script>
import MyDialog from "./components/locationDialog.vue";
import MyQrCodeDialog from "./components/qrCodeDialog.vue";
import apis from "@/apis/borrowingAnUmbrella";
import api from "@/apis/medal";
export default {
  name: "location",
  components: {
    MyDialog,
    MyQrCodeDialog,
  },
  data() {
    return {
      list: [],
      uploadDialog: false,
      uploadQrcodeDialog: false,
      itemList: {},
      imgUrl: "",
    };
  },
  mounted() {
    this.imgUrl = api.imgUrl;
    this.getList();
  },
  methods: {
    //添加
    add() {
      this.uploadDialog = true;
      this.itemList = {}
    },
    //编辑
    edit(i) {
      this.uploadDialog = true;
      this.itemList = i;
    },
    //显示二维码
    getCode(i) {
      this.uploadQrcodeDialog = true;
      this.itemList = i;
    },
    //获取列表
    getList() {
      apis.placeList().then((res) => {
        if (res.code == 200) {
          this.list = res.data;
          this.list.forEach((item) => {
            item.state = item.state == 1 ? true : false;
          });
        }
      });
    },
    changeSubmit() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.fullBox {
  width: 100%;
  height: 81vh;
  font-size: 11px * $zoom;
  // padding: 20px 20px 0;
  position: relative;
  overflow: auto;
  display: grid;
  grid-template-columns: 31% 31% 31%;
  grid-template-rows: 450px 450px 450px;
  row-gap: 6%;
  justify-content: space-between;
  &::-webkit-scrollbar {
    display: none;
  }
  .add_item {
    background: #fff;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4fa27d;
    font-size: 32px;
    i {
      margin-right: 20px;
      font-size: 40px;
    }
  }
  .item {
    background: #fff;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    padding: 40px;
    .top {
      display: flex;
      align-items: center;
      .left {
        margin-right: 40px;
        img {
          width: 270px;
          height: 270px;
          border-radius: 20px;
        }
      }
      .right {
        color: #969b9e;
        font-size: 28px;
        .title {
          font-size: 32px;
          margin-bottom: 30px;
          color: #000;
        }
        .address,
        .name {
          margin-bottom: 30px;
        }
        .state {
          display: flex;
          align-items: center;
        }
      }
    }
    .line {
      width: 100%;
      height: 2px;
      background: #eeeff2;
      margin-top: 30px;
    }
    .bot {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 26%;
      .left,
      .right {
        display: flex;
        align-items: center;
        font-size: 30px;
      }
      img {
        width: 45px;
        height: 45px;
        margin-right: 20px;
      }
    }
  }
}
</style>
